import React, { useState, useEffect } from 'react';
import { getFirestore, collection, getDocs, deleteDoc, doc, query, where } from 'firebase/firestore';
import { getStorage, ref, deleteObject } from 'firebase/storage';
import { useNavigate } from 'react-router-dom';
import { getAuth } from 'firebase/auth';
import useIsAdmin from './useIsAdmin.tsx';
import './Planche2.css';

interface Planche {
  titre: string;
  fichier: string;
  id: string;
}

function Planche2() {
  const navigate = useNavigate();
  const [planches, setPlanches] = useState<Planche[]>([]);
  const { isAdmin, loading: adminCheckLoading } = useIsAdmin();
  
  // Par défaut, on n'affiche pas le bouton
  const [showAddButton, setShowAddButton] = useState(false);

  const getStoragePathFromURL = (url: string) => {
    try {
      const regex = /firebasestorage\.googleapis\.com\/v0\/b\/[^/]+\/o\/([^?]+)/;
      const match = url.match(regex);
      if (match && match[1]) {
        const path = decodeURIComponent(match[1]);
        console.log('Chemin extrait:', path);
        return path;
      }
      return null;
    } catch (error) {
      console.error('Erreur lors de l\'extraction du chemin:', error);
      return null;
    }
  };

  useEffect(() => {
    const fetchPlanches = async () => {
      try {
        const db = getFirestore();
        const planchesSnapshot = await getDocs(collection(db, 'Planches2'));
        const planchesData = planchesSnapshot.docs.map(doc => ({
          id: doc.id,
          titre: doc.data().titre || '',
          fichier: doc.data().fichier || ''
        }));
        setPlanches(planchesData);
      } catch (error) {
        console.error('Erreur lors de la récupération des planches:', error);
      }
    };
    
    // Vérifier si l'utilisateur est Vénérable, Secrétaire OU administrateur
    const checkUserRole = async () => {
      try {
        const auth = getAuth();
        const user = auth.currentUser;
        
        if (user && user.email) {
          const db = getFirestore();
          
          const membresQuery = query(
            collection(db, 'Membres'),
            where('mail', '==', user.email)
          );
          
          const membresSnapshot = await getDocs(membresQuery);
          
          if (!membresSnapshot.empty) {
            const membreData = membresSnapshot.docs[0].data();
            const fonction = membreData.fonction || '';
            const estAdmin = membreData.administrateur === 'oui';
            
            // Vérifier si l'utilisateur est Vénérable OU Secrétaire OU administrateur
            if (fonction === 'Vénérable' || fonction === 'Secrétaire' || estAdmin) {
              console.log("Fonction de l'utilisateur:", fonction);
              console.log("Est administrateur:", estAdmin);
              console.log("Bouton 'Ajouter' affiché: Oui");
              setShowAddButton(true);
            } else {
              console.log("Fonction de l'utilisateur:", fonction);
              console.log("Est administrateur:", estAdmin);
              console.log("Bouton 'Ajouter' affiché: Non");
              setShowAddButton(false);
            }
          }
        }
      } catch (error) {
        console.error("Erreur lors de la vérification du rôle:", error);
      }
    };
    
    fetchPlanches();
    checkUserRole();
  }, []);

  const handleDownload = async (fichier: string) => {
    try {
      window.open(fichier, '_blank');
    } catch (error) {
      console.error('Erreur lors du téléchargement:', error);
    }
  };

  const handleDelete = async (id: string, fichierUrl: string) => {
    if (!isAdmin) {
      alert("Vous n'avez pas les droits d'administrateur nécessaires pour supprimer des fichiers.");
      return;
    }
    
    if (window.confirm('Êtes-vous sûr de vouloir supprimer cette planche ?')) {
      try {
        // Supprimer le fichier de Storage
        const storage = getStorage();
        const filePath = getStoragePathFromURL(fichierUrl);
        if (filePath) {
          const fileRef = ref(storage, filePath);
          try {
            await deleteObject(fileRef);
            console.log('Fichier supprimé du storage avec succès');
          } catch (storageError) {
            console.error('Erreur lors de la suppression du fichier:', storageError);
          }
        }
        // Supprimer le document de Firestore
        const db = getFirestore();
        const plancheRef = doc(db, 'Planches2', id);
        await deleteDoc(plancheRef);
        setPlanches(planches.filter(planche => planche.id !== id));
       
        console.log('Planche supprimée avec succès');
      } catch (error) {
        console.error('Erreur lors de la suppression:', error);
      }
    }
  };

  if (adminCheckLoading) {
    return <div>Chargement...</div>;
  }

  return (
    <div className="planches-container">
      <div className="button-container">
        {/* Afficher le bouton si l'utilisateur est Vénérable, Secrétaire OU administrateur */}
        {showAddButton && (
          <button
            className="ajouter-btn"
            onClick={() => navigate('/mapage/ajouter-planche-2')}
          >
            Ajouter
          </button>
        )}
      </div>
      <table className="planches-table">
        <thead>
          <tr>
            <th>Titre</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {planches.map((planche) => (
            <tr key={planche.id}>
              <td>{planche.titre}</td>
              <td>
                <div className="actions-container">
                  <button
                    onClick={() => handleDownload(planche.fichier)}
                    className="telecharger-btn"
                  >
                    Télécharger
                  </button>
                  {isAdmin && (
                    <button
                      onClick={() => handleDelete(planche.id, planche.fichier)}
                      className="supprimer-btn"
                    >
                      Supprimer
                    </button>
                  )}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default Planche2;